"use strict";

var _interopRequireDefault = require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.push.js");
require("core-js/modules/es.iterator.constructor.js");
require("core-js/modules/es.iterator.filter.js");
require("core-js/modules/es.iterator.find.js");
require("core-js/modules/es.iterator.for-each.js");
var _lodash = _interopRequireDefault(require("lodash"));
var _vue2Editor = require("vue2-editor");
var _log = require("@/utils/log");
var _lifehikesInitData = require("@/lifehikes-init-data");
var _utils = require("@/utils");
var _momentTimezone = _interopRequireDefault(require("moment-timezone"));
var _index = _interopRequireDefault(require("../../../../components/EventTime/index.vue"));
var _index2 = _interopRequireDefault(require("../../../../components/SearchBox/index.vue"));
var _hike = require("@/api/hike");
var _cookie = require("@/utils/cookie");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

const defaultValue = [];
var _default = exports.default = {
  name: "LoopProgram",
  components: {
    VueEditor: _vue2Editor.VueEditor,
    EventTime: _index.default,
    SearchBox: _index2.default
  },
  props: {
    parentPrograms: {
      type: Array,
      default: defaultValue
    },
    internalTitle: {
      type: String,
      default: ""
    },
    defaultTenant: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      loading: false,
      firstTab: "Program1",
      programIndex: 0,
      loopPrograms: [],
      hikeloopPrograms: [],
      customToolbar: [["bold"], [{
        list: "bullet"
      }]],
      timeZoneList: _lifehikesInitData.ianaTimeZone,
      programType: _lifehikesInitData.programType,
      programIcon: _lifehikesInitData.programIcon,
      programIconColor: _lifehikesInitData.programIconColor,
      showButton: _lifehikesInitData.showButton,
      selectShowButton: [],
      dialogHikeVisible: false,
      tableLoading: false,
      hikeList: [],
      total: 0,
      hikeQuery: {
        page: 1,
        limit: 10,
        sort: '-start.utc',
        q: undefined
      },
      programIndex: undefined,
      optoinIdx: undefined,
      loggedInUserTenants: [],
      selectedTenant: ""
    };
  },
  computed: {},
  watch: {
    loopPrograms: {
      handler(newVal) {
        let newLoopPrograms = newVal.concat(this.hikeloopPrograms);
        (0, _log.showDebugLog)("newLoopPrograms", newLoopPrograms);
        this.updateParentProgram(newLoopPrograms);
      },
      deep: true
    },
    selectShowButton: {
      handler(newVal) {
        (0, _log.showDebugLog)("newSelectShowButton", newVal);
        this.updateSelectShowButton(newVal);
      },
      deep: true
    },
    selectedTenant() {
      this.search(1);
    }
  },
  created() {
    this.loopPrograms = this.parentPrograms.filter(p => p.type !== "hike");
    this.loopPrograms.forEach((e, index) => {
      if (e.action.text !== "") {
        this.selectShowButton.push("Y");
      } else {
        this.selectShowButton.push("N");
      }
      if (e.options.length === 0) {
        console.info('第' + index + ' stage ' + e.options.length);
        e.options = [];
        this.addOption(index);
      }
    });
    console.info("selectShowButton:" + this.selectShowButton);
    this.hikeloopPrograms = this.parentPrograms.filter(p => p.type === "hike");
    //console.info("hikeloopPrograms:" + this.hikeloopPrograms);

    if (this.$store.getters.userMetadata && this.$store.getters.userMetadata.tenants) {
      this.loggedInUserTenants = this.$store.getters.userMetadata.tenants;
    }
    this.selectedTenant = this.defaultTenant;
  },
  methods: {
    addProgram() {
      const newProgram = {
        //id: "",
        type: "",
        title: "",
        shortDescription: "",
        start: {
          utc: "",
          timezone: _momentTimezone.default.tz.guess(),
          local: ""
        },
        end: {
          utc: "",
          timezone: _momentTimezone.default.tz.guess(),
          local: ""
        },
        classTime: "",
        icon: this.programIcon[0].val,
        iconColor: this.programIconColor[0].val,
        action: {
          text: "",
          url: "",
          message: ""
        },
        options: []
        // createdAt: "",
        // updatedAt: ""
      };
      this.loopPrograms.push(newProgram);
      let pLength = this.loopPrograms.length;
      this.firstTab = `Program${pLength}`;
      this.selectShowButton.push("Y");
    },
    copyLastProgram() {
      if (this.loopPrograms.length > 0) {
        const targetIdx = this.loopPrograms.length - 1;
        var newProgram = _lodash.default.cloneDeep(this.loopPrograms[targetIdx]);
        delete newProgram.id;
        delete newProgram.createdAt;
        delete newProgram.updatedAt;
        this.loopPrograms.push(newProgram);
        let pLength = this.loopPrograms.length;
        this.firstTab = `Program${pLength}`;
        let temp = this.selectShowButton[targetIdx];
        this.selectShowButton.push(temp);
      } else {
        (0, _log.displayPopupMessage)("Nothing to copy", "info");
      }
    },
    removeProgram(idx) {
      this.loopPrograms.splice(idx, 1);
      this.firstTab = idx === 0 ? `Program1` : `Program${idx}`;
      console.info("selectShowButton之前：" + this.selectShowButton);
      this.selectShowButton.splice(idx, 1);
      console.info("selectShowButton之后：" + this.selectShowButton);
    },
    moveNext(index) {
      if (index < this.loopPrograms.length) {
        console.info("selectShowButton之前：" + this.selectShowButton);
        var element = _lodash.default.cloneDeep(this.loopPrograms[index]);
        var element2 = _lodash.default.cloneDeep(this.loopPrograms[index + 1]);
        this.$set(this.loopPrograms, index, element2);
        this.$set(this.loopPrograms, index + 1, element);
        this.firstTab = `Program${index + 2}`;
        let temp = this.selectShowButton[index];
        let nextIndex = index + 1;
        this.selectShowButton[index] = this.selectShowButton[nextIndex];
        this.selectShowButton[nextIndex] = temp;
        this.$forceUpdate();
        console.info("selectShowButton之后：" + this.selectShowButton);
      }
    },
    movePrevious(index) {
      if (index > 0) {
        console.info("selectShowButton之前：" + this.selectShowButton);
        var element = _lodash.default.cloneDeep(this.loopPrograms[index]);
        var element2 = _lodash.default.cloneDeep(this.loopPrograms[index - 1]);
        this.$set(this.loopPrograms, index - 1, element);
        this.$set(this.loopPrograms, index, element2);
        this.firstTab = `Program${index}`;
        let temp = this.selectShowButton[index];
        let nextIndex = index - 1;
        this.selectShowButton[index] = this.selectShowButton[nextIndex];
        this.selectShowButton[nextIndex] = temp;
        this.$forceUpdate();
        console.info("selectShowButton之后：" + this.selectShowButton);
      }
    },
    updateParentProgram(res) {
      this.$emit("updateParentProgram", res);
    },
    updateSelectShowButton(res) {
      this.$emit("updateSelectShowButton", res);
    },
    setShowButtom(e, index) {
      if (e === "N") {
        this.loopPrograms[index].action.text = "";
        this.loopPrograms[index].action.url = "";
        this.loopPrograms[index].action.message = "";
        this.$forceUpdate();
      }
    },
    addOption(programIndex) {
      const newOption = {
        objectId: '',
        objectType: 'hike',
        objectData: {
          title: ''
        }
      };
      this.loopPrograms[programIndex].options.push(newOption);
    },
    removeOption(programIndex, optoinIdx) {
      this.loopPrograms[programIndex].options.splice(optoinIdx, 1);
    },
    moveOptionUp(programIndex, optoinIdx) {
      let options = this.loopPrograms[programIndex].options;
      let currentOptoin = options[optoinIdx];
      this.$set(options, optoinIdx, options[optoinIdx - 1]);
      this.$set(options, optoinIdx - 1, currentOptoin);
    },
    moveOptionDown(programIndex, optoinIdx) {
      let options = this.loopPrograms[programIndex].options;
      let currentOptoin = options[optoinIdx];
      this.$set(options, optoinIdx, options[optoinIdx + 1]);
      this.$set(options, optoinIdx + 1, currentOptoin);
    },
    addHikeInOptions(id, title) {
      const option = this.loopPrograms[this.programIndex].options[this.optoinIdx];
      option.objectId = id;
      option.objectData.title = title;
      this.dialogHikeVisible = false;
      this.programIndex = undefined;
      this.optoinIdx = undefined;
    },
    clearHikeResource(programIndex, optoinIdx) {
      const option = this.loopPrograms[programIndex].options[optoinIdx];
      option.objectId = "";
      option.objectData.title = "";
    },
    openHikeDialog(programIndex, optoinIdx) {
      this.programIndex = programIndex;
      this.optoinIdx = optoinIdx;
      this.dialogHikeVisible = true;
      // Reset search state and filter by the loop's tenant on every open
      this.hikeQuery.q = undefined;
      this.hikeQuery.page = 1;
      this.selectedTenant = this.defaultTenant;
      this.search(1);
    },
    search(pageNo) {
      this.hikeQuery.page = pageNo;
      this.hikeQuery.q = this.hikeQuery.q === '' ? undefined : this.hikeQuery.q;
      this.getList();
    },
    handleSizeChange(val) {
      this.hikeQuery.limit = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.hikeQuery.page = val;
      this.getList();
    },
    getList() {
      const token = (0, _cookie.getCookie)('ACCESS_TOKEN');
      this.tableLoading = true;
      const query = {
        ...this.hikeQuery
      };
      if (this.selectedTenant) {
        query.tenant = this.selectedTenant;
      }
      (0, _log.showDebugLog)('Hike query', query);
      (0, _hike.getHikeList)(token, query).then(response => {
        (0, _log.showDebugLog)('Hike-Search-response', response);
        this.hikeList = response.data.rows;
        this.total = response.data.count;
        this.tableLoading = false;
      }).catch(error => {
        (0, _log.showDebugLog)('hike-Search-error', error);
        this.tableLoading = false;
        (0, _log.displayPopupMessage)(error, 'error');
        // this.$message({ type: 'error', showClose: true, duration: 5000, message: error.response })
      });
    },
    getHikeCategory(val) {
      if (val === '' || typeof val === 'undefined') {
        return '';
      } else {
        const hikeCategory = _lifehikesInitData.HikeCategory.find(p => p.val === val);
        return hikeCategory === null || hikeCategory === undefined ? "" : hikeCategory.description;
      }
    },
    getTenantLabel(val) {
      return (0, _utils.getTenantLabel)(val);
    },
    selectType(e, index) {
      if (e === "externalAction") {
        this.loopPrograms[index].options = [];
        this.addOption(index);
      } else if (e === "info") {
        this.loopPrograms[index].action.url = "";
        //clear all options
        this.loopPrograms[index].options = [];
        this.addOption(index);
      } else {
        //clear all options
        this.loopPrograms[index].options = [];
        this.loopPrograms[index].action.message = "";
        this.loopPrograms[index].action.url = "";
        this.addOption(index);
      }
    }
  }
};